<aside class="box" [attr.aria-labelledby]="headingId">
  <div class="row">
    <span class="icon" aria-hidden="true"><mat-icon>warning</mat-icon></span>
    <p class="heading" [class.heading--clipped]="collapsible() && !expanded()" [id]="headingId">{{ heading() }}</p>
    @if (collapsible()) {
      <button
        type="button"
        class="toggle"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="detailId"
        (click)="toggle()"
      >
        {{ toggleLabel() }}
        <mat-icon aria-hidden="true">{{ expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    }
    @if (dismissible()) {
      <button type="button" class="close" aria-label="Zavrieť oznam" (click)="dismissed.emit()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>
  @if (collapsible()) {
    <div class="detail" [class.detail--open]="expanded()" [id]="detailId">
      <div class="detail-inner">
        <seiri-rich-text class="body" [html]="content()" />
      </div>
    </div>
  }
</aside>
